import React from 'react'
import { Link } from 'react-router-dom'
import casemi from "../../img/casemi.png";
const Casemi = () => {
      return (
         <div className="bg-latitud animated fadeIn" >
            <div className="container section">
               <div className="row">
                  <div className="center-vertical">
                        <div className="col s12 m12 l6 x6 center">
                           <Link to={"https://casemi.com.ar/"}  target="_blank"><img src={casemi} className="responsive-img circle"/></Link>
                        </div>
                        <div className="col s12  m12 l6  x6 center text-white">
                           <strong style={{"font-size":"25px"}}>CASEMI</strong><br/><br/>
                           <strong style={{"font-size":"20px"}}>Estamos Asociados a la Camara de Servicios Mineros de Jujuy</strong><br/><br/><br/>
                           <Link to={"https://casemi.com.ar/"} target="_blank" className="btn btn-large waves-effect waves-light text-gray  white pulse" type="submit" name="action">Visitar
                              <i className="material-icons right">send</i>
                           </Link>
                        </div>
                  </div>
               </div>
            </div>
         </div>
      )
}

export default Casemi